<template>
	<NuxtLayout>
		<NuxtLoadingIndicator color="var(--cta-blue-color)" />
		<NuxtPage />
	</NuxtLayout>
</template>
